const KEY = 'current-user-id';
const ACTIVATION_STATUS_KEY = 'ACTIVATION_STATUS';

export function readCurrentUserId() {
  return localStorage.getItem(KEY);
}

export function writeCurrentUserId(id) {
  localStorage.setItem(KEY, id);
}

export function removeCurrentUserId() {
  localStorage.removeItem(KEY);
}

export function readActivationStatus() {
  return localStorage.getItem(ACTIVATION_STATUS_KEY);
}

export function writeActivationStatus(id) {
  localStorage.setItem(ACTIVATION_STATUS_KEY, id);
}

export function removeActivationStatus() {
  localStorage.removeItem(ACTIVATION_STATUS_KEY);
}
